import { Reference, Property, Name, Output } from '@components/Reference';
import { Spacer } from "@cleartrip/bento/lib";
import Sandbox from '@components/Sandbox';
import * as React from 'react';
export default {
  Reference,
  Property,
  Name,
  Output,
  Spacer,
  Sandbox,
  React
};